import { IBasicProfile } from './lmsProfile.model'

export interface IPermissions {
  canAnswer: boolean
  canDownload: boolean
  canEdit: boolean
  canMonitor: boolean
  canRequest: boolean
  canMonitoringAreas: boolean
  canManageCourses: boolean
}

export interface IPermissionModel {
  loading: boolean
  local: boolean
  admin: boolean
  superadmin: boolean
  supervisor: boolean
  moderator: boolean
  permissions: IPermissions
  lmsProfiles?: (IPermissions & {
    profile: IBasicProfile
  })[]
}

export const permissionInitialState: IPermissionModel = {
  loading: true,
  local: false,
  admin: false,
  superadmin: false,
  supervisor: false,
  moderator: false,
  permissions: {
    canAnswer: false,
    canDownload: false,
    canEdit: false,
    canMonitor: false,
    canRequest: false,
    canMonitoringAreas: false,
    canManageCourses: false,
  },
  lmsProfiles: [],
}
